// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Common = require("../utils/Common.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");

function logClientIsSendingRequest(clientId, procName, req, reqToStr) {
  var reqStr = Belt_Option.getWithDefault(Belt_Option.map(reqToStr, (function (f) {
              return Curry._1(f, req);
            })), "");
  console.log("" + Common.currTimeStr(undefined) + " [" + String(clientId) + "," + procName + "] C~> " + reqStr + "");
}

function logClientReceivedResponse(clientId, procName, resp, respToStr) {
  var respStr = Belt_Option.getWithDefault(Belt_Option.map(respToStr, (function (f) {
              return Curry._1(f, resp);
            })), "");
  console.log("" + Common.currTimeStr(undefined) + " [" + String(clientId) + "," + procName + "] ->C " + respStr + "");
}

function logWorkerIsSendingResponse(clientId, procName, resp, respToStr) {
  console.log("" + Common.currTimeStr(undefined) + " [" + String(clientId) + "," + procName + "] W~> " + Curry._1(respToStr, resp) + "");
}

function logWorkerReceivedRequest(clientId, procName, req, reqToStr) {
  console.log("" + Common.currTimeStr(undefined) + " [" + String(clientId) + "," + procName + "] ->W " + Curry._1(reqToStr, req) + "");
}

function serialize(prim) {
  return prim;
}

function deserialize(prim) {
  return prim;
}

exports.serialize = serialize;
exports.deserialize = deserialize;
exports.logClientIsSendingRequest = logClientIsSendingRequest;
exports.logClientReceivedResponse = logClientReceivedResponse;
exports.logWorkerIsSendingResponse = logWorkerIsSendingResponse;
exports.logWorkerReceivedRequest = logWorkerReceivedRequest;
/* No side effect */
